module.exports = __webpack_public_path__ + "static/DesireesAngel-a8051e778e528b73d5ab49172d121722.jpg";